export default __webpack_public_path__ + "static/media/cloth_3.ad68e40a.jpg";